<div>
  <submission-loading v-if="!showSubmission" :id="$vId(this)" />
  <div v-if="!submittingSubmission && submission.status === 'in_review'" class="mt-block">
    <v-grid class="mt-wrapper" contain>
      <v-row class="mt-section">
        <v-col has="8" off="2">
          <h1 class="mt-h3">{{$t('pages.submissions.index.submitted.already')}}</h1>
          <p
            :class="$style.notifyContentBottom"
            class="mt-serif mt-serif--size2"
            v-html="$sanitize($t('pages.submissions.index.submitted.whats_next'))"
          ></p>
          <p
            :class="$style.notifyContentBottom"
            class="mt-serif mt-serif--size2"
            v-html="$sanitize($t('pages.submissions.index.submitted.whats_next'))"
          ></p>
        </v-col>
      </v-row>
      <v-row class="mt-section mt-section--submit">
        <v-col has="8" off="2">
          <button
            type="button"
            :id="$vId(this, 'return-dashboard')"
            class="mt-button"
            @click="routeToHome"
          >
            {{$t('pages.submissions.index.submitted.to_dashboard')}}
          </button>
        </v-col>
      </v-row>
    </v-grid>
  </div>

  <div v-if="showSubmission && submission.status === 'in_correction'" class="mt-block">
    <div class="mt-wrapper">  
      <message-history
        :id="$vId(this, 'message-history')"
        v-bind:messageHistory="submissionMessageHistory"
      ></message-history>
      <fou-container :id="$vId(this, 'correct-form')" cols="12" background padded>
        <template #header>
          <h5 class="mt-h5">{{$t('pages.submissions.correct.title')}} {{submissionFamilyName}}</h5>
        </template>
        <template #content>
          <v-grid>
            <!-- steps -->
            <v-row class="mt-group">
              <v-col has="10" off="1">
                <fou-accordion :class="$style.accordion">
                  <fou-accordion-item
                    open
                    :id="$vId(this, 'upload-section')"
                    :class="accordionItemClassForUploadSection"
                  >
                    <template #heading>
                      <div :class="[$style.headingUpload, $style.heading]">
                        <h2 class="mt-h2" :class="$style.title">
                          {{$t('pages.submissions.components.upload.heading')}}
                        </h2>
                      </div>
                    </template>
                    <template #content>
                      <upload :id="$vId(this)" :class="$style.accordionContent"> </upload>
                    </template>
                  </fou-accordion-item>
                  <fou-accordion-item :id="$vId(this, 'prices-section')" :class="accordionItemClassForPriceSection">
                    <template #heading>
                      <div :class="[$style.headingPrices, $style.heading]">
                        <h2 class="mt-h2" :class="$style.title">
                          {{$t('pages.submissions.components.prices.heading')}}
                        </h2>
                      </div>
                    </template>
                    <template #content>
                      <prices :id="$vId(this)" :class="$style.accordionContent"> </prices>
                    </template>
                  </fou-accordion-item>

                  <fou-accordion-item
                    :id="$vId(this, 'descriptions-section')"
                    :class="accordionItemClassForDescriptionSection"
                  >
                    <template #heading>
                      <div :class="[$style.headingDesc, $style.heading]">
                        <h2 class="mt-h2" :class="$style.title">
                          {{$t('pages.submissions.components.descriptions.heading')}}
                        </h2>
                      </div>
                    </template>
                    <template #content>
                      <descriptions :id="$vId(this)" :class="$style.accordionContent"> </descriptions>
                    </template>
                  </fou-accordion-item>

                  <fou-accordion-item
                    :id="$vId(this, 'descriptions-section')"
                    :class="accordionItemClassForGraphicsSection"
                  >
                    <template #heading>
                      <div :class="[$style.headingImages, $style.heading]">
                        <h2 class="mt-h2" :class="$style.title">
                          {{$t('pages.submissions.components.graphics.heading')}}
                        </h2>
                      </div>
                    </template>
                    <template #content>
                      <graphics :id="$vId(this)" slot="content"> </graphics>
                    </template>
                  </fou-accordion-item>
                </fou-accordion>
              </v-col>
            </v-row>
            <!-- # steps end -->
          </v-grid>
        </template>
      </fou-container>
      <channels :foundryId="submissionFoundryId" v-if="showChannnels"></channels>
      <fou-container :id="$vId(this, 'correct-submit-form')" cols="12" background padded :class="$style.description">
        <template #header>
          <div>
            <h2 class="mt-h5" v-html="$t('pages.submissions.correct.description')"></h2>
            <p class="mt-serif mt-serif--size4" v-html="$t('pages.submissions.correct.description_s')"></p>
          </div>
        </template>
        <template #content>
          <v-grid>
            <v-row>
              <v-col has="10" off="1">
                <section class="mt-section">
                  <FouTextArea
                    :id="$vId(this, 'support-note')"
                    name="support note"
                    :input-class="['mt-textarea mt-line', {'mt-input--error': Object.hasOwn(errors, 'support note')}]"
                    v-model="description"
                    maxlength="5000"
                    rows="9"
                    rules="max:5000||script_tag_validate"
                    :placeholder="$t('pages.submissions.components.confirmation.type_here')"
                  ></FouTextArea>
                </section>
              </v-col>
            </v-row>

            <v-row v-if="!submission.isLive">
              <v-col has="10" off="1" :class="$style.reviewErrors">
                <date-scheduler :errors="errors" :id="$vId(this)" />
              </v-col>
            </v-row>

            <v-row :class="$style.submit">
              <v-col has="10" off="1">
                <button
                  :id="$vId(this, 'submit')"
                  type="button"
                  :disabled="stepsErrors.length || requiredErrorsOnly || !isEmpty(errors) ||submission.status === 'in_review'"
                  class="mt-button mt-group--bottom-medium"
                  @click="submitCorrection"
                >
                  {{$t('pages.submissions.correct.action.submit')}}
                </button>
                <div v-if="stepsErrors.length || requiredErrorsOnly">
                  <fou-group class="mt-error"> {{$t('pages.submissions.index.errors')}} </fou-group>
                  <ul class="mt-list">
                    <li v-if="requiredErrorsOnly" class="mt-list-item mt-error mt-error--padded mt-line">
                      <p class="mt-line">{{requiredErrorsOnly}}</p>
                    </li>
                    <li v-for="step in stepsErrors" class="mt-list-item mt-error mt-error--padded mt-line">
                      <p class="mt-line" v-for="err in step" v-html="$sanitize(err)"></p>
                    </li>
                  </ul>
                </div>
                <div :class="$style.supportSubmitButton" v-if="uniqueStyleErrors.length > 0">
                  <ul class="mt-list">
                    <li
                      v-for="uniqError in removeDuplicates(uniqueStyleErrors, true)"
                      class="mt-list-item mt-error mt-error--padded mt-line"
                    >
                      <p
                        class="mt-line"
                        v-html="$t('pages.submissions.index.live_unique_style_error', {styleName : uniqError.styleName})" 
                      \>
                      </p>
                    </li>
                  </ul>
                </div>
                <fou-group class="mt-error" v-if="submissionLimitError">
                  {{$tc('pages.submissions.index.in_review_submissions_limit_reached')}}
                </fou-group>
              </v-col>
            </v-row>
          </v-grid>
        </template>
      </fou-container>
    </div>
  </div>
</div>
